module.exports = __webpack_public_path__ + "img/icon_feedback.fb4bba5d.svg";